import React from 'react';

type Props = {
  errors: string[];
};

export const ValidationErrors = ({ errors }: Props) => {
  if (errors.length === 0) return null;

  return (
    <div className="bg-red-50 text-red-700 p-4 rounded-lg space-y-2">
      <div className="font-medium">يوجد أخطاء في الملف:</div>
      <ul className="text-sm list-disc list-inside">
        {errors.map((error, index) => (
          <li key={index}>{error}</li>
        ))}
      </ul>
    </div>
  );
};